export default __webpack_public_path__ + "static/media/DEPARIS_01.a63e53fd.gif";